import { render, staticRenderFns } from "./BlogPostMedia.vue?vue&type=template&id=6015fd4d&"
import script from "./BlogPostMedia.vue?vue&type=script&lang=ts&"
export * from "./BlogPostMedia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports